export enum SaveStatuses {
    Normal,
    Saving,
    Saved,
    Error,
    Updated
}

export enum Status {
    Neutral = 'neutral',
    Info = 'info',
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
}
